import React, { useState, useEffect, useContext, useRef } from "react";
import "../../css_files/Master/BoilerSeriesPartsMappingMaster.css";
import Table from "../Homepage/Table";
import AddBoilerSeriesPartsMappingMaster from "./AddBoilerSeriesPartsMappingMaster";
import SearchBoilerSeriesPartsMappingMaster from "./SearchBoilerSeriesPartsMappingMaster";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import Pagination from "../Homepage/Pagination";
import axiosInstance from "../../api";
import BoilerPartsDataTable from "./BoilerPartsDataTable";

function BoilerSeriesPartsMappingMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = [
    "Id",
    "Head",
    "Series Code",
    "Description",
    "Display All Parts",
  ];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [boilerseriespartsupdatedata, setboilerseriespartsupdatedata] =
    useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [pagenumber, setpagenumber] = useState(1);
  const [pagecount, setpagecount] = useState(0);
  const [showboilerpartsdata, setshowboilerpartsdata] = useState(false);
  const [boilerpartsdataloading, setboilerpartsdataloading] = useState(false);
  const [totalcount, setTotalCount] = useState(0);

  const [search, setSearch] = useState("");
  const [Ids, setIds] = useState([]);
  const [SubIds, setSubIds] = useState([]);
  const [boilerSeriesPartsMapperId, setboilerSeriesPartsMapperId] =
    useState(null);

  function fetchboilerseriespartsdata(boilerseriespartsid, show = false) {
    setboilerpartsdataloading(true);
    setboilerseriespartsupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/GetBoilerPartsMapperByIdOrSeriesCode?id=${boilerseriespartsid}&page=1`;
    axiosInstance
      .get(url)
      .then((res) => {
        setboilerseriespartsupdatedata(res.data.data[0]);
        setboilerpartsdataloading(false);
        setshowboilerpartsdata(show);
      })
      .catch((err) => {
        setboilerpartsdataloading(false);
        setshowboilerpartsdata(show);
      });
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/BoilerPartsMapper/${pagenumber}`;
    axiosInstance
      .post(URL, {
        Id: boilerSeriesPartsMapperId || null,
        Search: search,
        Ids,
        SubIds,
      })
      .then((response) => {
        setpagecount(response.data.count);
        setTotalCount(response.data.dataCount);
        setTableData(
          response.data.data.map((x) => [
            x.id,
            x.boiler.head,
            x.boilerSeries.seriesCode,
            x.description,
            "Tap here to See More Details",
          ])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload, pagenumber, Ids.length, SubIds.length]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series Parts Mapping" &&
        x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series Parts Mapping" &&
        x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series Parts Mapping" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Boiler Series Parts Mapping" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="boiler-series-parts-mapping-master">
      <h1>Boiler-Series Parts Mapping Master</h1>
      <blockquote className="boiler-series-parts-mapping-master-forms">
        <AddMaster
          text="Add Boiler-Series Parts Mapping Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Boiler-Series Parts Mapping Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddBoilerSeriesPartsMappingMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          boilerseriespartsupdatedata={boilerseriespartsupdatedata}
          key={`${boilerseriespartsupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchBoilerSeriesPartsMappingMaster
          setshowsearchform={setshowsearchform}
          setpagenumber={setpagenumber}
          setIds={setIds}
          setSubIds={setSubIds}
          setBoilerSeriesPartsMapperId={setboilerSeriesPartsMapperId}
          setReload={setReload}
          setSearch={setSearch}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchboilerseriespartsdata}
        url="BoilerPartsMapper/UpdateBoilerPartsMapper"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
        totalcount={totalcount}
      />
      <Pagination
        count={pagecount}
        setpagenumber={setpagenumber}
        pagenumber={pagenumber}
      />
      {showboilerpartsdata && (
        <BoilerPartsDataTable
          data={boilerseriespartsupdatedata?.parts ?? []}
          loading={boilerpartsdataloading}
          close={setshowboilerpartsdata}
        />
      )}
    </section>
  );
}

export default BoilerSeriesPartsMappingMaster;
